import { createUseStyles } from "react-jss";

const useStyles = createUseStyles(theme => ({
  settingsItem: {
    marginTop: 10,
    marginBottom: 5,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    "& input": {
      marginLeft: 30,
      height: 30,
      flexShrink: 0,
      width: "50%",
      maxWidth: 300,
      outline: "none",
      "border-radius": 4,
      padding: "3px 9px",
      fontSize: 15,
      border: "1px solid transparent",
      background: theme.colorBackground,
      color: "white",
      fontFamily: "DaytonaPro-Light",
      "&:focus": {
        border: `1px solid ${theme.colorPrimary} !important`,
      },
    },
  },
  row: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  image: {
    width: 30,
    height: 30,
    marginRight: 8,
  },
}));

const getHotspotIcon = name => `${window.location.origin}/assets/hotspots/${name}.png`;

const TYPES = {
  'link': {
    icon: getHotspotIcon('direction'),
    label: 'Navigate',
  },
  'web': {
    icon: getHotspotIcon('web-link'),
    label: 'Web',
  },
  'fade': {
    icon: getHotspotIcon('crossfade'),
    label: 'Crossfade',
  },
  'elevate-up': {
    icon: getHotspotIcon('elevate-up'),
    label: 'Ascend',
  },
  'elevate-down': {
    icon: getHotspotIcon('elevate-down'),
    label: 'Descend',
  },
  'media': {
    icon: getHotspotIcon('info-plus'),
    label: 'Media',
  },
  'gallery': {
    icon: getHotspotIcon('gallery'),
    label: 'Gallery',
  },
  'audio': {
    icon: getHotspotIcon('audio'),
    label: 'Audio',
  },
  'poi': {
    icon: getHotspotIcon('poi'),
    label: 'Look at',
  },
  'timeline': {
    icon: getHotspotIcon('timeline'),
    label: 'Timeline',
  },
  'info': {
    icon: getHotspotIcon('info'),
    label: 'Information',
  },
}

export const ExploreIconsEditor = (props) => {
  const { value, onChange } = props;
  const classes = useStyles();

  return (
    <div>
      {Object.keys(TYPES).map((key, idx) => {
        const item = TYPES[key];
        const valueKey = `icon_${key}`;
        return (
          <div className={classes.settingsItem} key={`hotspot_label_${idx}`}>
            <div className={classes.row}>
              <img src={item.icon} alt={`hotspot_icon_${key}`} className={classes.image} />
              <label>{item.label}:</label>
            </div>
            <input
              value={value?.[valueKey]}
              onChange={ev =>
                onChange(valueKey, ev)
              }
            />
          </div>
        )
      })}
    </div>
  )
}
